import R from 'ramda'

export default (page, action) => (dispatch, getState) => {
  if(action.type != 'finished'){ return }
  localStorage.setItem(`${page}-tour-completed`, true)
  const tourStatus = getState().completedTours
  const updatedStatus = R.assoc(page, true, tourStatus)
  dispatch({type: 'save_completed_tours', completedTours: updatedStatus})
  
}



/** WEBPACK FOOTER **
 ** ./app/actions/registerTourComplition.js
 **/